import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-select-payment-method',
  templateUrl: './select-payment-method.component.html',
  styleUrls: ['./select-payment-method.component.scss']
})
export class SelectPaymentMethodComponent implements OnInit {

  selectedMethod: 'cash' | 'ewallet' | null = null;

  constructor(
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

  hideModal(){
    this.modalService.hideSelectPaymentMethod();
  }

}
